<template>
  <div>
    <search-form
      ref="searchForm"
      :loading="loading"
      :mode="TASK_TYPE_ENUM.MATCH"
      :buss-type="mode"
      @search="handleSearch"
    ></search-form>

    <el-card v-loading="loading" class="m-t-md">
      <el-radio-group v-if="mode === LEVEL_ONE_APPEAL.OFFLINE.code" v-model="showExtra">
        <el-radio-button :label="0">简略模式</el-radio-button>
        <el-radio-button :label="1">详细信息</el-radio-button>
      </el-radio-group>
      <span style="float:right">
        <el-button type="primary" @click="handleShowBatchDownload">全量导出</el-button>
        <el-button v-if="canCheck" type="primary" @click="handleShowBatchUpload">批量上传</el-button>
        <el-button v-if="canCheck" type="primary" @click="handleShowBatchEdit">批量修改</el-button>
        <el-button v-if="canCheck" type="primary" @click="handleShowBatchDelete">批量删除</el-button>
      </span>
      <br>
      <br>

      <el-table :data="tableData" @selection-change="handleSelectChange">
        <!-- <el-table-column v-if="canCheck" type="selection"></el-table-column> -->
        <el-table-column align="center" label="匹配结果信息">
          <el-table-column label="匹配结果ID" width="100" prop="pkId"></el-table-column>
          <el-table-column label="授权版权信息" width="160" show-overflow-tooltip v-slot="{ row }">
            <p>授权方：{{ row.matchCompanyName || '-' }}</p>
            <p>原始授权方：{{ row.matchOriginCompanyName || '-' }}</p>
          </el-table-column>
          <el-table-column label="歌曲&视频信息" width="310" v-slot="{ row }">
            <track-info-mod :data="row.matchInfo"></track-info-mod>
          </el-table-column>
        </el-table-column>
        <complaint-info-col v-if="mode === LEVEL_ONE_APPEAL.TORT.code"></complaint-info-col>
        <offline-info-col v-else-if="mode === LEVEL_ONE_APPEAL.OFFLINE.code" :show-extra="!!showExtra"></offline-info-col>
        <white-list-info-col v-else-if="mode === LEVEL_ONE_APPEAL.WHITE_LIST.code"></white-list-info-col>
        <notice-info-col v-else></notice-info-col>
        <complaint-task-info-col></complaint-task-info-col>
        <el-table-column
          align="center"
          fixed="left"
          width="240"
          label="审核信息"
        >
          <template #default="{ row }">
            <div class="action-wrapper">
              <section class="action-item">
                <label>状态：</label>
                <span>{{ matchStatusMap[row.pkStatus] }}</span>
              </section>
              <section class="action-item">
                <label>期限：</label>
                <span>{{ row.expiresTime }}</span>
              </section>
              <section v-if="row.confirmRightFileInfo && row.confirmRightFileInfo.fileUrl" class="action-item">
                <label>重复版权方上传权利文件：</label>
                <a :href="$toPreview(row.confirmRightFileInfo.fileUrl)" target="_blank">{{ row.confirmRightFileInfo.fileName }}</a>
              </section>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          v-if="canCheck"
          align="center"
          fixed="left"
          width="120"
          label="操作"
          #default="{ row }"
        >
          <el-button
            type="primary"
            class="edit_btn"
            @click="handleShowEdit(row)"
          >
            编辑
          </el-button>

          <el-popconfirm
            confirm-button-text="确认"
            cancel-button-text="取消"
            icon="el-icon-info"
            icon-color="red"
            title="确认删除？"
            @confirm="handleDelete(row.pkId)"
          >
            <el-button
              slot="reference"
              type="primary"
              :loading="deletingId === row.pkId"
            >
              删除
            </el-button>
          </el-popconfirm>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pagination.current"
        :page-sizes="[20, 50, 100, 200, 5000]"
        :page-size="pagination.size"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
      >
      </el-pagination>
    </el-card>

    <batch-upload-dialog
      :visible.sync="showBatchUpload"
      :mode="TASK_TYPE_ENUM.MATCH"
      :buss-type="mode"
      :need-right="false"
      @submit="handleUpload"
    ></batch-upload-dialog>
    <batch-edit-dialog
      ref="batch-edit-dialog"
      :visible.sync="showBatchEdit"
      :loading="saving"
      :mode="TASK_TYPE_ENUM.MATCH"
      @submit="batchSave"
    ></batch-edit-dialog>
    <batch-download-dialog :visible.sync="showBatchDownload" :mode="mode" :params="getSearchParams()"></batch-download-dialog>

    <batch-delete-dialog
      :visible.sync="showBatchDelete"
      :mode="TASK_TYPE_ENUM.MATCH"
      :buss-type="mode"
      :loading="batchDeleting"
      @submit="batchDelete"
    >
    </batch-delete-dialog>

    <MatchEditDialog
      :visible.sync="showEdit"
      :edit-data="editData"
      :loading="editing"
      @submit="handleSubmitEdit"
    >
    </MatchEditDialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import complaintService from '@/api/complaint'
import { MatchList } from '@/models/Complaint'
import { paginationTableMixin } from '@/utils/mixins'

import SearchForm from '../../SearchForm.vue'
import BatchUploadDialog from '../../BatchUploadDialog.vue'
import BatchEditDialog from '../../BatchEditDialog.vue'
import BatchDownloadDialog from '../../BatchDownloadDialog.vue'
import BatchDeleteDialog from '../../BatchDeleteDialog.vue'
import TrackInfoMod from '../../TrackInfoMod'
import ComplaintInfoCol from '../../ComplaintInfoCol.vue'
import OfflineInfoCol from '../../OfflineInfoCol.vue'
import WhiteListInfoCol from '../../WhiteListInfoCol.vue'
import ComplaintTaskInfoCol from '../../ComplaintTaskInfoCol.vue'
import NoticeInfoCol from '../../NoticeInfoCol.vue'
import MatchEditDialog from './MatchEdit.vue'

import {
  MATCH_STATUS,
  TASK_TYPE_ENUM,
  LEVEL_ONE_APPEAL,
  matchStatusMap,
} from '../../../const'

export default {
  name: 'CombineTable',
  components: {
    SearchForm,
    BatchUploadDialog,
    BatchEditDialog,
    BatchDownloadDialog,
    BatchDeleteDialog,
    TrackInfoMod,
    ComplaintInfoCol,
    OfflineInfoCol,
    WhiteListInfoCol,
    ComplaintTaskInfoCol,
    NoticeInfoCol,
    MatchEditDialog,
  },
  mixins: [paginationTableMixin],
  props: {
    mode: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      TASK_TYPE_ENUM,
      LEVEL_ONE_APPEAL,
      matchStatusMap,

      showExtra: 0,
      loading: false,
      showBatchUpload: false,
      showBatchEdit: false,
      showBatchDownload: false,
      showBatchDelete: false,
      saving: false,
      batchDeleting: false,
      selection: [],

      showEdit: false,
      editing: false,
      editData: {},
      deletingId: undefined
    }
  },
  computed: {
    ...mapGetters([
      'isEditor',
      'isAdmin'
    ]),
    /**
     * @returns {Boolean}
     */
    canCheck() {
      return this.isEditor || this.isAdmin
    }
  },
  methods: {
    getSearchParams() {
      return this.$refs.searchForm ? this.$refs.searchForm.getParams() : null
    },
    async fetchData() {
      const params = this.getSearchParams()
      if (!params) return this.$message.warning('请输入任一条件进行查询')

      this.loading = true
      try {
        const resp = await complaintService.findMatchList({
          ...params,
          bussType: this.mode,
          page: this.pagination.current - 1,
          num: this.pagination.size
        })
        this.pagination.total = resp.total
        this.tableData = (resp.list || []).map(v => new MatchList(v))
      } catch (error) {
        this.$alert(`查询失败.${error.message}`, '错误', {
          type: 'error'
        })
      }
      this.loading = false
    },
    handleShowBatchEdit() {
      this.showBatchEdit = true
    },

    handleShowBatchUpload() {
      this.showBatchUpload = true
    },

    handleShowBatchDownload() {
      this.showBatchDownload = true
    },

    handleShowBatchDelete() {
      this.showBatchDelete = true
    },

    async handleUpload(fileList, rightFileList) {
      try {
        const params = {
          url: fileList[0].url,
          mode: TASK_TYPE_ENUM.MATCH,
          complaintType: this.mode,
          rightFileList
        }
        await complaintService.batchUpload(params)
        this.$message.success('上传成功')
      } catch (error) {
        this.$alert(`上传失败.${error.message}`, '错误', {
          type: 'error'
        })
      }
    },

    handleSelectChange(selection) {
      this.selection = selection
    },

    async batchSave(data, fileList, rightFileList) {
      function genItem(data) {
        return {
          id: data.pkId,
          tmeId: data.tmeId,
          audioType: data.audioType,
          status: data.status,
          expiresTime: data.expiresTime,
          createUser: data.createUser,
          legalAffairs: data.legalAffairs,
          historyCompany: data.historyCompany
        }
      }

      const postData = { list: [] }
      if (!data) {
        if (!this.selection.length) {
          return this.$message.warning('请选中需要修改的记录')
        }

        postData.list = this.selection.map(item => genItem({ ...item, status: item.pkStatus }))
      } else {
        const { ids, tmeIdList, ...rest } = data
        postData.list = ids.length ? ids.map(pkId => genItem({ ...rest, pkId })) : tmeIdList.map(tmeId => genItem({ ...rest, tmeId }))

        if (fileList.length) {
          postData.url = fileList[0].url
          postData.complaintType = this.mode
        }

        if (rightFileList.length) {
          postData.rightFileList = rightFileList
        }
      }

      if (postData.list.some(v => v.status === MATCH_STATUS.REPEAT_RIGHT.code)) {
        try {
          await this.$confirm('提交作品选择坚持权利。请再次确认，权利处理结果及证明材料完整，一经提交不可修改', '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          })
        } catch {
          return
        }
      }

      this.saving = true
      try {
        await complaintService.saveMatchList(postData)
        this.$message.success('保存成功')

        this.showBatchEdit = false

        if (postData.list?.length) {
          const ids = postData.list.map(v => v.id).filter(Boolean)
          const tmeIdList = postData.list.map(v => v.tmeId).filter(Boolean)
          if (ids.length) {
            this.$refs.searchForm.setParam('pkIdList', ids)
          } else if (tmeIdList.length) {
            this.$refs.searchForm.setParam('tmeIdList', tmeIdList)
          }
        }

        if (this.$refs['batch-edit-dialog']) {
          this.$refs['batch-edit-dialog'].close()
        }

        // 防止两个 message 重叠
        this.$nextTick(() => {
          this.handleSearch()
        })
      } catch (error) {
        this.$alert(`保存失败.${error.message}`, '错误', {
          type: 'error'
        })
      }
      this.saving = false
    },

    handleShowEdit(row) {
      this.editData = row
      this.showEdit = true
    },

    async handleSubmitEdit(data) {
      this.editing = true
      try {
        await complaintService.editMatch(data)
        this.$message.success('编辑成功！')

        this.showEdit = false
        this.editRow = { }

        this.handleSearch()
      } catch (err) {
        this.$message.error('编辑失败：' + err.message)
      }
      this.editing = false
    },

    async handleDelete(id) {
      if (this.deletingId !== undefined) {
        this.$message.warning('其他数据删除中！请稍后尝试！')
        return
      }
      this.deletingId = id
      await this.batchDelete([id])
      this.deletingId = undefined
    },

    async batchDelete(ids) {
      this.batchDeleting = true
      const postData = {
        idList: ids
      }
      try {
        await complaintService.deleteMatch(postData)
        this.$message.success('删除成功！')
        this.showBatchDelete = false

        this.$nextTick(() => {
          this.handleSearch()
        })
      } catch (err) {
        this.$message.error('删除失败！' + err.message)
      }
      this.batchDeleting = false
    }
  }
}
</script>

<style lang="scss" scoped>
.action-wrapper {
  .action-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    label {
      white-space: nowrap;
    }
  }
}
</style>
